import React from "react";
import { Outlet, NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { useI18n } from "@/i18n/I18nContext";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();

  const onLogout = () => {
    logout();
    navigate("/login");
  };

  const linkBase =
    "px-4 py-3 font-mono text-[10px] tracking-widest2 uppercase border-l-2 border-transparent transition-colors duration-500";
  const linkActive = "border-gold text-gold bg-gold/5";
  const linkIdle = "text-cream/65 hover:text-cream hover:border-gold/40";

  return (
    <div className="min-h-screen bg-ink-grain text-cream flex" data-testid="admin-layout">
      <aside className="w-[260px] hidden md:flex flex-col border-r border-gold/15">
        <div className="p-6 border-b border-gold/15">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-8 h-8 border border-gold/60 flex items-center justify-center font-display text-gold text-lg">
              R
            </div>
            <div className="leading-tight">
              <div className="font-display italic text-cream text-base">Ramirez</div>
              <div className="font-mono text-[9px] tracking-widest2 uppercase text-gold/70">Archive Console</div>
            </div>
          </Link>
        </div>

        <nav className="flex flex-col py-4">
          <NavLink to="/admin" end className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkIdle}`} data-testid="admin-nav-dashboard">
            {t("admin.dashboard")}
          </NavLink>
          <NavLink to="/admin/submissions" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkIdle}`} data-testid="admin-nav-submissions">
            {t("admin.submissions")}
          </NavLink>
          <NavLink to="/admin/archive" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkIdle}`} data-testid="admin-nav-archive">
            {t("admin.archive")}
          </NavLink>
          <NavLink to="/admin/cellar" className={({ isActive }) => `${linkBase} ${isActive ? linkActive : linkIdle}`} data-testid="admin-nav-cellar">
            {t("admin.cellar")}
          </NavLink>
        </nav>

        <div className="mt-auto p-6 border-t border-gold/15 space-y-3">
          <div className="font-mono text-[9px] tracking-widest2 uppercase text-cream/40">Steward</div>
          <div className="text-cream/85 text-sm">{user?.email}</div>
          <Link
            to="/"
            className="block font-mono text-[10px] tracking-widest2 uppercase text-cream/55 hover:text-gold transition-colors"
            data-testid="admin-view-site"
          >
            ← {t("admin.view_site")}
          </Link>
          <button
            onClick={onLogout}
            className="font-mono text-[10px] tracking-widest2 uppercase text-cream/55 hover:text-destructive transition-colors"
            data-testid="admin-logout"
          >
            {t("admin.logout")}
          </button>
        </div>
      </aside>

      {/* mobile top bar */}
      <header className="md:hidden fixed top-0 inset-x-0 z-30 bg-ink/95 border-b border-gold/15 flex items-center justify-between px-4 py-3">
        <Link to="/admin" className="font-display italic text-cream">Ramirez · Console</Link>
        <button onClick={onLogout} className="font-mono text-[10px] tracking-widest2 uppercase text-cream/60">
          {t("admin.logout")}
        </button>
      </header>

      <main className="flex-1 p-6 md:p-12 pt-20 md:pt-12 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
